import type { FaireProductEntity } from "../../entity_types/product";

export const p_yqkhe6q3c7: FaireProductEntity = {
  token: "p_yqkhe6q3c7",
  type: "product",
  name: "I Like Books More Than People Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/a901926b9b01f3a95fa51f15f7725d751a51f3dc630972afe157dde2ca42635b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c098964161d1eb09f8f59897b2965ec8beef8484dec5170db32b0474ac5e3750.jpeg",
    "https://cdn.faire.com/fastly/6b093785f7913744b3fb85da753ee313548dbc908d26f0675dc2eca5cb91a542.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/bc841a3b0ec7969f290cf6dd6b149b51f921104fbf8bb327cfa2c2cf5ae79063.jpeg",
    "https://cdn.faire.com/fastly/2adf5b93fdf16cc585dfcc5bd4c08e1be2e2bf761375087dc7f3ad87df461e69.jpeg",
    "https://cdn.faire.com/fastly/aa0ae80d7d80189e0a4fdf7230c76fa113df06b0f3a50d1d727b48c86791d77d.jpeg",
    "https://cdn.faire.com/fastly/80638b81dee2eb32e7bb3430c418aae33ee49fb80e403b208f2a407844d20095.jpeg"
  ],
  priceDollars: 6.75,
  description: "When you're a well-read introvert who’d rather cancel plans than dog-ear a page, you deserve some quality reading socks (even though you ignore most of your texts). 📚\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:54.138Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
